/**
 * RegExp for quickly extracting the environment from the URL
 * @type {RegExp}
 */
export const QUICK_ENV = /.*?-(.*?)\.(cldnet|corpnt)\.analog\.com/gi;

/**
 * Prod environment
 * @type {string}
 */
export const PROD_ENV = 'prod';

/**
 * Gives a name for the current environment
 * @param {boolean} removeSuffix Removes suffix numbers from the environment string
 * @returns {string} Name of the environment
 */
export const getEnv = ( removeSuffix = true ) => {
	const { host } = window.location,
		matches = host.matchAll( QUICK_ENV ).next();

	if ( host.startsWith( 'local' ) ) return 'dev';

	let env = matches.value ? matches.value[ 1 ] : PROD_ENV;
	if ( removeSuffix ) env = env.replace( /[0-9]/, '' );
	return env;
};

/**
 * Creates a URL based on the current environment
 * @param {string} subDomain page subdomain
 * @param {string} [network] page network
 * @param {boolean} [includeProtocol] Determines if the current environment's hypertext
 * protocol should be included
 * @param {boolean} [includeEnvironmentSuffix] Determines if the current environment's
 * suffix (e.g. the `2` in `dev2` ) should be included
 * @returns {string} generated env url
 */
export const createEnvironmentURL = ( subDomain, network = 'cldnet', includeProtocol = true, includeEnvironmentSuffix = false ) => {
	const tld = 'analog.com',
		protocol = 'https:',
		environment = getEnv( !includeEnvironmentSuffix );
	if ( environment === PROD_ENV ) {
		return `${includeProtocol ? `${protocol}//` : ''}${subDomain}.${tld}`;
	}
	return `${includeProtocol ? `${protocol}//` : ''}${subDomain}-${environment}.${network}.${tld}`;
};